import { Icon } from "@resource/atlas";
import { atlasArchive } from "@resource/atlas/icons";
import {
  EmailTemplateStatusEnum,
  InterviewTemplateStatusEnum,
  PostTemplateStatusEnum,
  StageTemplateStatusEnum,
} from "generated/schemaTypes";
import _ from "lodash";
import { UseTableCellProps } from "react-table";

function TemplateTableNameCell({
  value,
  row,
}: UseTableCellProps<
  {
    name: string;
    department?: {
      name: string;
    };
    status?:
      | InterviewTemplateStatusEnum
      | StageTemplateStatusEnum
      | EmailTemplateStatusEnum
      | PostTemplateStatusEnum;
  },
  string
>) {
  const { status, department } = row.original;
  const isArchived =
    status === InterviewTemplateStatusEnum.ARCHIVED ||
    status === StageTemplateStatusEnum.ARCHIVED ||
    status === EmailTemplateStatusEnum.ARCHIVED ||
    status === PostTemplateStatusEnum.ARCHIVED;
  return (
    <>
      <div className="flex flex-shrink truncate">
        <span className="text-body-md truncate">{value}</span>
        {isArchived && (
          <Icon
            content={atlasArchive}
            size="medium"
            className="ml-2 text-subtle"
          />
        )}
      </div>
      {department && (
        <div className="text-body-sm text-subtle truncate">
          {_.capitalize(department.name)}
        </div>
      )}
    </>
  );
}

export default TemplateTableNameCell;
